"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginize = paginize;
exports.withBody = exports.withParams = exports.withHeaders = exports.extendOptionalObject = exports.withOptional = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var withOptional = function withOptional(key, value) {
  return function (optionals) {
    return _objectSpread(_objectSpread({}, optionals), {}, (0, _defineProperty2["default"])({}, key, value));
  };
};

exports.withOptional = withOptional;

var extendOptionalObject = function extendOptionalObject(key, value) {
  return function (optionals) {
    if (key in optionals) {
      // Key already exist, we need to extend
      return _objectSpread(_objectSpread({}, optionals), {}, (0, _defineProperty2["default"])({}, key, _objectSpread(_objectSpread({}, optionals[key]), value)));
    } else {
      return _objectSpread(_objectSpread({}, optionals), {}, (0, _defineProperty2["default"])({}, key, value));
    }
  };
};

exports.extendOptionalObject = extendOptionalObject;

var withHeaders = function withHeaders(headers) {
  return extendOptionalObject('headers', headers);
};

exports.withHeaders = withHeaders;

var withParams = function withParams(params) {
  return extendOptionalObject('params', params);
};

exports.withParams = withParams;

var withBody = function withBody(body) {
  return extendOptionalObject('body', body);
};
/**
 * Helper method that includes function calls to the next and previous
 * paginated links.
 */


exports.withBody = withBody;

function paginize(f, params) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var _params$pagination = params.pagination,
      page = _params$pagination.page,
      limit = _params$pagination.limit;
  return function (o) {
    var next = null;
    var previous = null;

    if (!(0, _isNil["default"])(o.next)) {
      next = function next() {
        var nextParams = _objectSpread(_objectSpread({}, params), {}, {
          pagination: {
            limit: limit,
            page: page + 1
          }
        });

        return f.apply(void 0, args.concat([nextParams]));
      };
    }

    if (!(0, _isNil["default"])(o.previous)) {
      previous = function previous() {
        var prevParams = _objectSpread(_objectSpread({}, params), {}, {
          pagination: {
            limit: limit,
            page: page - 1
          }
        });

        return f.apply(void 0, args.concat([prevParams]));
      };
    }

    return {
      results: o.results,
      next: next,
      previous: previous
    };
  };
}
//# sourceMappingURL=helpers.js.map